import {Component} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '@shared/services/security/auth.service';
import {SpinnerComponent} from '@shared/components/spinner/spinner.component';
import {Roles} from "@models/roles.enum";

@Component({
    selector: 'app-select-type',
    imports: [CommonModule, ReactiveFormsModule, SpinnerComponent],
    providers: [],
    templateUrl: './select-type.component.html',
    styleUrl: './select-type.component.scss'
})
export class SelectTypeComponent {
    form!: FormGroup;
    errorMessage!: string;
    loading = false;
    roles = this.authService.roles.includes(<Roles>'Admin')
    type = this.authService.getCurrentType()

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private router: Router,
        public toastr: ToastrService
    ) {
    }

    ngOnInit(): void {
        if (this.authService.getCurrentType() != "" && this.authService.getCurrentType() != 'cdssadmin') {
            this.router.navigate(['']);
        }
        this.form = this.fb.group({
            type: ['', [Validators.required]],
        });
    }

    onSubmit() {
        if (this.form.valid) {
            this.loading = true
            const type = this.form.value.type;
            this.authService.setCurrentType(type)
            this.router.navigate(['']);
            this.toastr.success('Selected Platform: ' + type + '', ' ');
            this.loading = false
        } else {
            // Mark fields as touched to trigger validation messages
            this.form.markAllAsTouched();
        }
    }
}
